import { cmsAxios } from "./config/axiosConfig";

// Get all modules
export const getAllModules = async () => {
  try {
    const response = await cmsAxios.get("/cms/modules/list");
    return response.data;
  } catch (error: any) {
    console.error("Failed to fetch modules:", error);
    throw error?.response?.data || error;
  }
};

// Create a new module
export const createModule = async (moduleData: {
  moduleName: string;
  moduleDescription: string;
  courseId: string;
  courseLearningLink: { linkDisplayName: string | null; url: string | null }[];
}) => {
  try {
    const response = await cmsAxios.post("/cms/modules/create", moduleData);
    return response.data;
  } catch (error: any) {
    console.error("Failed to create module:", error);
    throw error?.response?.data || error;
  }
};

// Update an existing module
export const updateModule = async (
  moduleId: string,
  moduleData: {
    moduleName: string;
    moduleDescription: string;
    courseId: string;
    courseLearningLink: {
      linkDisplayName: string | null;
      url: string | null;
    }[];
    isActive: boolean; // Note: different format than POST
  }
) => {
  try {
    const response = await cmsAxios.put(`/cms/modules/${moduleId}`, moduleData);
    return response.data;
  } catch (error: any) {
    console.error(`Failed to update module ${moduleId}:`, error);
    throw error?.response?.data || error;
  }
};
